import * as ScrollResizeHandler from '../services/ScrollResizeHandler';
import keycode from 'keycode';
import trim from '../utilities/trimSpaces';
import SubPub from '../utilities/subpub';


const DocumentSubPub = new SubPub;
const callbacks = [];

// const logoLink = Array.from(document.getElementsByClassName('main-header__brand'));
// const navLinks = Array.from(document.getElementsByClassName('main-header__nav-link'));
// const footerLinks = Array.from(document.querySelectorAll('.footer-fineprint__links a'));
// const trackedLinks = [...logoLink, ...navLinks, ...footerLinks];

/**
 * --------------------------------------------------------------------------------------------
 * HELPER FUNCTIONS
 * --------------------------------------------------------------------------------------------
 */

// Handle focus
document.addEventListener('focus', function (e) {
  DocumentSubPub.publish('DOCUMENT_FOCUS', e);
}, true);


// Handle keypress
document.addEventListener('keypress', function (e) {
  e.keyName = keycode(e.keyCode);
  DocumentSubPub.publish('DOCUMENT_KEYPRESS', e);
}, true);

// Handle keyup
document.addEventListener('keyup', function (e) {
  e.keyName = keycode(e.keyCode);
  DocumentSubPub.publish('DOCUMENT_KEYUP', e);
}, true);

// Handle keydown
document.addEventListener('keydown', function (e) {
  e.keyName = keycode(e.keyCode);
  DocumentSubPub.publish('DOCUMENT_KEYDOWN', e);
}, true);

// Handle body click
document.addEventListener('click', function (e) {
  DocumentSubPub.publish('DOCUMENT_CLICK', e);
}, true);

// trackedLinks.forEach(item => {
//   if ( item.isBound ) { return; }

//   item.addEventListener('click', function (e) {
//     ga('send', {
//       hitType: 'event',
//       eventCategory: 'Navigation Link',
//       eventAction: 'click',
//       eventLabel: `Item Clicked: ${trim(this.textContent)}`
//     });
//   });

//   item.isBound = true;
// });



/**
 * --------------------------------------------------------------------------------------------
 * EXPORTS
 * --------------------------------------------------------------------------------------------
 */



export function onFocus (callback) {
  DocumentSubPub.subscribe('DOCUMENT_FOCUS', callback)
}

export function onKeyPress (callback) {
  DocumentSubPub.subscribe('DOCUMENT_KEYPRESS', callback)
}

export function onKeyDown (callback) {
  DocumentSubPub.subscribe('DOCUMENT_KEYDOWN', callback)
}

export function onKeyUp (callback) {
  DocumentSubPub.subscribe('DOCUMENT_KEYUP', callback)
}

export function onResizeDebounced (callback) {
  ScrollResizeHandler.onResizeDebounced(callback);
}

export function onClick (callback) {
  DocumentSubPub.subscribe('DOCUMENT_CLICK', callback);
}
